import React from 'react';
var SecondaryLogoClearanceSVG = function SecondaryLogoClearanceSVG(_ref) {
    var width = _ref.width, svgClassName = _ref.svgClassName, clearanceClassName = _ref.clearanceClassName, specsClassName = _ref.specsClassName, specMarkersClassName = _ref.specMarkersClassName, logoClassName = _ref.logoClassName;
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 720 230",
        width: width,
        className: svgClassName
    }, /*#__PURE__*/ React.createElement("g", {
        className: logoClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M240.22,115.58c-5.91,0-10.09,3.31-12.01,6.44V99.31h-12.01v62.9h12.01v-27.32c0-4.87,3.22-8.53,8.26-8.53 c4.09,0,7.57,3.13,7.57,8.18v27.66h11.92v-26.27C255.97,126.28,253.27,115.58,240.22,115.58z M285.81,115.58 c-12.96,0-22.27,10.26-22.27,24.01c0,13.66,9.31,23.75,23.92,23.75c11.31,0,17.4-6.79,19.14-10l-7.92-6 c-1.3,1.91-4.87,5.57-11.05,5.57c-6.7,0-11.57-4.35-11.83-10.44h32.01c0.09-0.87,0.09-1.74,0.09-2.61 C307.9,124.98,299.9,115.58,285.81,115.58z M276.15,134.63c0.52-5.22,4.18-9.22,9.83-9.22c5.48,0,9.48,3.65,9.74,9.22H276.15z M335.13,115.58c-6.96,0-13.83,2.61-17.92,5.39l4.52,8.18c3.39-1.74,7.57-3.22,12.09-3.22c5.31,0,8.26,2.7,8.26,6.7v2.96 c-1.65-1.13-5.22-2.52-9.83-2.52c-10.61,0-17.66,6.09-17.66,15.05c0,9.57,7.83,15.22,17.05,15.22c5.22,0,8.7-1.57,11.05-4.09 l0.78,2.96h10.61v-28.8C354.09,123.23,349.74,115.58,335.13,115.58z M334.52,154.03c-4.52,0-7.92-2.52-7.92-6.26 c0-3.74,3.22-6.35,7.83-6.35c4.61,0,7.92,2.35,7.92,6.35C342.35,151.6,339.04,154.03,334.52,154.03z M365.57,162.21h12v-62.9h-12 V162.21z M395.59,98.88c-3.91,0-6.96,2.96-6.96,6.87c0,3.91,3.05,6.87,6.96,6.87c4,0,7.05-2.96,7.05-6.87 C402.63,101.83,399.59,98.88,395.59,98.88z M389.67,162.21h12v-45.5h-12V162.21z M435.95,115.58c-5.91,0-10.26,3.31-12.18,6.44 v-5.31h-11.74v45.5h12.01v-27.32c0-4.87,3.13-8.53,8.09-8.53c4.09,0,7.57,3.13,7.57,8.18v27.66h12.01v-26.27 C451.7,126.28,448.91,115.58,435.95,115.58z M494.76,121.49c-1.3-1.74-5.92-5.91-13.57-5.91c-12.96,0-22.18,9.92-22.18,23.92 s8.61,23.84,21.75,23.84c7.92,0,12.35-4.52,13.31-5.83v2.09c0,7.05-6,9.05-12.53,9.05c-6.26,0-11.48-2.35-12.96-3.13l-3.65,9.22 c4.09,2.26,10.44,4.18,16.7,4.18c13.4,0,24.45-5.48,24.45-22.45v-39.76h-11.31V121.49z M482.75,152.73 c-6.79,0-11.66-5.31-11.66-13.31c0-8,4.78-13.22,11.57-13.22c7.05,0,11.74,5.48,11.74,13.22 C494.41,147.51,489.71,152.73,482.75,152.73z M541.47,115.58c-7.83,0-12.35,4.35-13.48,5.91V99.31h-12.01v62.9h11.31v-4.7 c1.22,1.48,5.74,5.83,13.48,5.83c13.05,0,22.27-9.83,22.27-23.84C563.05,125.41,554.52,115.58,541.47,115.58z M539.3,152.73 c-7.31,0-11.66-5.92-11.66-13.14c0-8.53,5.05-13.4,11.66-13.4c6.96,0,11.66,5.48,11.66,13.4 C550.95,147.68,546.08,152.73,539.3,152.73z M594.45,115.58c-13.83,0-24.45,10.18-24.45,24.01c0,13.75,10.27,23.75,24.45,23.75 c14.27,0,24.53-10,24.53-23.75S608.37,115.58,594.45,115.58z M594.45,152.73c-7.13,0-12.44-5.39-12.44-13.14 c0-7.83,5.22-13.4,12.44-13.4c7.22,0,12.53,5.65,12.53,13.4C606.98,147.33,601.67,152.73,594.45,152.73z M650.12,138.98 l15.31-22.27h-13.49l-8.53,13.83l-8.52-13.83h-13.49l15.31,22.27l-16.01,23.23h12.96l9.74-14.27l9.66,14.27h13.05L650.12,138.98z M180.68,121.61c2.74-6.13,2.62-14.18,2.5-17.19c-0.12-3-0.48-8.05-0.6-9.73c-0.12-1.68-0.39-3.66-1.61-4.55 c-0.7-0.51-2.71-1.56-17.61,3.51c-11.92,4.06-15.47,12.94-16.4,16.51c-0.44,1.7-0.44,4.85-0.44,5.67v17.91c0,0.02,0,0.04,0,0.07 c0,0.02,0,0.04,0,0.07v19.38c0,1.55,0.19,3.84,0.64,5.74c0.97,3.56,4.27,11.79,16.19,15.85c14.9,5.07,16.91,4.03,17.61,3.51 c1.22-0.9,1.49-2.87,1.61-4.55s0.48-6.73,0.6-9.73c0.12-3,0.24-11.06-2.5-17.19c-2.53-5.67-9.04-10.8-15.38-12.64 C171.64,132.4,178.14,127.27,180.68,121.61z M113.22,93.65c-14.9-5.07-16.91-4.03-17.61-3.51c-1.22,0.9-1.49,2.87-1.61,4.55 c-0.12,1.68-0.48,6.73-0.6,9.73c-0.12,3-0.24,11.06,2.5,17.19c2.53,5.67,9.04,10.8,15.38,12.64c-6.34,1.84-12.84,6.97-15.38,12.64 c-2.74,6.13-2.62,14.18-2.5,17.19c0.12,3,0.48,8.05,0.6,9.73s0.39,3.66,1.61,4.55c0.7,0.51,2.71,1.56,17.61-3.51 c11.92-4.06,15.22-12.3,16.19-15.85c0.46-1.91,0.64-4.2,0.64-5.74v-19.38c0-0.02,0-0.04,0-0.07c0-0.02,0-0.04,0-0.07v-17.91 c0-0.82,0-3.97-0.44-5.67C128.69,106.59,125.14,97.71,113.22,93.65z"
    })), /*#__PURE__*/ React.createElement("g", {
        className: clearanceClassName
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M715.18,71.68h-0.27V40.76H44.17v30.91h-0.3v114.33h0.3v41.05H714.9v-41.05h0.27V71.68z M667.1,88.84v90.14 H91.95V88.84H667.1z"
    })), /*#__PURE__*/ React.createElement("g", {
        className: specsClassName
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "714.9,43.76 714.9,40.76 711.9,40.76",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "705.94",
        y1: "40.76",
        x2: "673.12",
        y2: "40.76",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "670.14,40.76 667.14,40.76 667.14,43.76",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "667.14",
        y1: "49.78",
        x2: "667.14",
        y2: "82.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "667.14,85.84 667.14,88.84 670.14,88.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "676.1",
        y1: "88.84",
        x2: "708.92",
        y2: "88.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "711.9,88.84 714.9,88.84 714.9,85.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "714.9",
        y1: "79.83",
        x2: "714.9",
        y2: "46.77",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "714.9,182.75 714.9,179.75 711.9,179.75",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "705.94",
        y1: "179.75",
        x2: "673.12",
        y2: "179.75",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "670.14,179.75 667.14,179.75 667.14,182.75",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "667.14",
        y1: "188.76",
        x2: "667.14",
        y2: "221.82",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "667.14,224.83 667.14,227.83 670.14,227.83",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "676.1",
        y1: "227.83",
        x2: "708.92",
        y2: "227.83",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "711.9,227.83 714.9,227.83 714.9,224.83",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "714.9",
        y1: "218.82",
        x2: "714.9",
        y2: "185.76",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "91.64,43.76 91.64,40.76 88.64,40.76",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "82.67",
        y1: "40.76",
        x2: "49.85",
        y2: "40.76",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "46.87,40.76 43.87,40.76 43.87,43.76",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "43.87",
        y1: "49.78",
        x2: "43.87",
        y2: "82.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "43.87,85.84 43.87,88.84 46.87,88.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "52.84",
        y1: "88.84",
        x2: "85.65",
        y2: "88.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "88.64,88.84 91.64,88.84 91.64,85.84",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "91.64",
        y1: "79.83",
        x2: "91.64",
        y2: "46.77",
        vectorEffect: "non-scaling-stroke"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("polyline", {
        points: "91.64,181.99 91.64,178.99 88.64,178.99",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "82.67",
        y1: "178.99",
        x2: "49.85",
        y2: "178.99",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "46.87,178.99 43.87,178.99 43.87,181.99",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "43.87",
        y1: "188",
        x2: "43.87",
        y2: "221.06",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "43.87,224.06 43.87,227.06 46.87,227.06",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "52.84",
        y1: "227.06",
        x2: "85.65",
        y2: "227.06",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("polyline", {
        points: "88.64,227.06 91.64,227.06 91.64,224.06",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "91.64",
        y1: "218.05",
        x2: "91.64",
        y2: "184.99",
        vectorEffect: "non-scaling-stroke"
    })), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("line", {
        x1: "91.38",
        y1: "41.17",
        x2: "91.38",
        y2: "38.17",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "91.38",
        y1: "32.18",
        x2: "91.38",
        y2: "11.23",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "91.38",
        y1: "8.23",
        x2: "91.38",
        y2: "5.23",
        vectorEffect: "non-scaling-stroke"
    })), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("line", {
        x1: "44.1",
        y1: "87.79",
        x2: "41.1",
        y2: "87.79",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "35.11",
        y1: "87.79",
        x2: "14.15",
        y2: "87.79",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ React.createElement("line", {
        x1: "11.16",
        y1: "87.79",
        x2: "8.16",
        y2: "87.79",
        vectorEffect: "non-scaling-stroke"
    }))))), /*#__PURE__*/ React.createElement("g", {
        className: specMarkersClassName
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M81.68,64.13c3.2-0.93,6.48-3.52,7.76-6.38c1.38-3.09,1.32-7.16,1.26-8.68c-0.06-1.52-0.24-4.07-0.3-4.91 c-0.06-0.85-0.19-1.85-0.81-2.3c-0.35-0.26-1.37-0.79-8.89,1.77c-6.02,2.05-7.81,6.53-8.28,8.33c-0.22,0.86-0.22,2.45-0.22,2.86 v9.04c0,0.01,0,0.02,0,0.03c0,0.01,0,0.02,0,0.03v9.79c0,0.78,0.09,1.94,0.33,2.9c0.49,1.8,2.15,5.95,8.17,8 c7.52,2.56,8.54,2.03,8.89,1.77c0.62-0.45,0.75-1.45,0.81-2.3c0.06-0.85,0.24-3.4,0.3-4.91c0.06-1.52,0.12-5.58-1.26-8.68 C88.16,67.65,84.88,65.06,81.68,64.13z M55.38,43.63c-7.52-2.56-8.54-2.03-8.89-1.77c-0.62,0.45-0.75,1.45-0.81,2.3 c-0.06,0.85-0.24,3.4-0.3,4.91c-0.06,1.52-0.12,5.58,1.26,8.68c1.28,2.86,4.57,5.45,7.76,6.38c-3.2,0.93-6.48,3.52-7.76,6.38 c-1.38,3.09-1.32,7.16-1.26,8.68c0.06,1.52,0.24,4.07,0.3,4.91c0.06,0.85,0.19,1.85,0.81,2.3c0.35,0.26,1.37,0.79,8.89-1.77 c6.02-2.05,7.68-6.21,8.17-8c0.23-0.96,0.33-2.12,0.33-2.9v-9.79c0-0.01,0-0.02,0-0.03c0-0.01,0-0.02,0-0.03v-9.04 c0-0.41,0-2-0.22-2.86C63.19,50.16,61.4,45.68,55.38,43.63z M56.98,25.22c-1.23,0-1.83-0.69-1.98-1.72h-1.22 c0.08,1.55,1.09,2.79,3.19,2.79c1.99,0,3.36-1.27,3.36-3.26c0-1.91-1.27-3.03-3.04-3.03c-1.01,0-1.65,0.39-2.09,0.92l0.24-3.07h4.3 l0.04-1.12h-5.38l-0.35,5.22l1.09,0.11c0.41-0.59,1.04-1.01,1.93-1.01c1.2,0,1.99,0.71,1.99,1.99 C59.08,24.45,58.16,25.22,56.98,25.22z M65.89,16.56c-2.3,0-3.63,2.09-3.63,4.89c0,2.8,1.3,4.83,3.59,4.83c2.31,0,3.64-2.1,3.64-4.9 C69.48,18.56,68.2,16.56,65.89,16.56z M65.87,25.19c-1.56,0-2.34-1.62-2.35-3.75c0.01-2.13,0.8-3.78,2.35-3.78 c1.57,0,2.34,1.61,2.34,3.74S67.44,25.19,65.87,25.19z M77.84,23.42c0,1.7,0.88,2.83,2.23,2.83s2.23-1.13,2.23-2.83 c0-1.6-0.88-2.68-2.23-2.68S77.84,21.83,77.84,23.42z M81.32,23.44c0,1.15-0.5,1.91-1.25,1.91c-0.76,0-1.25-0.76-1.25-1.91 c0-1.09,0.49-1.79,1.25-1.79C80.81,21.65,81.32,22.35,81.32,23.44z M75.71,19.26c0-1.6-0.88-2.68-2.23-2.68 c-1.36,0-2.23,1.08-2.23,2.68c0,1.69,0.87,2.83,2.23,2.83C74.83,22.09,75.71,20.96,75.71,19.26z M72.24,19.28 c0-1.09,0.49-1.79,1.25-1.79c0.74,0,1.25,0.7,1.25,1.79c0,1.15-0.5,1.91-1.25,1.91C72.73,21.18,72.24,20.43,72.24,19.28z M74.28,26.11l6.08-9.41h-0.99l-6.09,9.41H74.28z"
    })), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M91.38,5.63c-1.04,1.04-3.11,1.54-4.54,1.58c1.92-1.43,3.6-3.29,4.54-5.55c0.9,2.25,2.68,4.03,4.54,5.55 C94.39,7.1,92.53,6.72,91.38,5.63z"
    })))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M8.56,87.79c1.04,1.04,1.54,3.11,1.58,4.54c-1.43-1.92-3.29-3.6-5.55-4.54c2.25-0.9,4.03-2.68,5.55-4.54 C10.02,84.78,9.65,86.64,8.56,87.79z"
    }))))));
};
export default SecondaryLogoClearanceSVG;
